module.exports = __webpack_public_path__ + "2e266c3a778591af482dc1c7da3611d3.png";


//////////////////
// WEBPACK FOOTER
// ../assets/247-edmonton-devices.png
// module id = 514
// module chunks = 0